import React from "react";
import "./imgList.scss";

const ImgList = ({ title, listImg }) => {
    return (
        <div className="imgList">
            <h3 className="textBox__title">{title}</h3>

            <div className="imgList__img">
                {listImg.map((item, index) => (
                    <img key={index} src={item} alt={`listed-${index}`} />
                ))}
            </div>
        </div>
    );
};

export default ImgList;
